export default __webpack_public_path__ + "static/media/community_pre_image.8a04aa6e.svg";